var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prezzo_polizza",attrs:{"id":_vm.id_element},on:{"click":_vm.selectProduct}},[_vm._v(_vm._s(_vm.productmonthlyprice)+"€"),_c('span',[_vm._v("mensili")])])}
var staticRenderFns = []

export { render, staticRenderFns }